import { render, staticRenderFns } from "./hugeDeviceAcemtUp.vue?vue&type=template&id=60abda31&scoped=true"
import script from "./hugeDeviceAcemtUp.vue?vue&type=script&lang=js"
export * from "./hugeDeviceAcemtUp.vue?vue&type=script&lang=js"
import style0 from "./hugeDeviceAcemtUp.vue?vue&type=style&index=0&id=60abda31&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60abda31",
  null
  
)

export default component.exports